import { apiService } from "../api";


/**
 * 2. POST /pdiu/program/{program_id}
 */
export async function createPdiuProgram(programId: string, payload: object) {
  const response = await apiService({
    url: `/pdiu/program/${programId}`,
    method: "post",
    protectedRoute: true,
    requestData: payload,
  });
  return response;
}

/**
 * 3. GET /pdiu/program/{program_id}
 */
export async function getPdiuProgram(programId: string) {
  const response = await apiService({
    url: `/pdiu/program/${programId}`,
    method: "get",
    protectedRoute: true,
  });
  return response;
}